import { useEffect } from "react";

import useSelectedStore from "./use-selected-store";
import log from "../logger";

const useSetStoreFromLocalStorage = () => {
  const { selectedStore, setSelectedStore } = useSelectedStore();

  useEffect(() => {
    if (!selectedStore.id) {
      const selectedStoreName = localStorage.getItem("selectedStoreName");
      const selectedStoreId = localStorage.getItem("selectedStoreId");
      const selectedStoreAddress = localStorage.getItem("selectedStoreAddress");

      try {
        const parsedAddress = JSON.parse(selectedStoreAddress);
        if (selectedStoreName && selectedStoreId && selectedStoreAddress) {
          setSelectedStore({
            ...selectedStore,
            id: selectedStoreId ?? null,
            name: selectedStoreName ?? null,
            address: parsedAddress ?? null,
          });
        }
      } catch (error) {
        log.error(`Error parsing store address from local storage: ${error}`, {
          tags: {
            functionName: "useSetStoreFromLocalStorage",
          },
        });
      }
    }
  }, [selectedStore.id]);
};

export default useSetStoreFromLocalStorage;
